import styled, {keyframes} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Link} from 'components/ui-kit/Link';
import {breakpoint, colors} from 'theme';

export const ColumnsWrapper = styled.div`
    display: flex;
    gap: 40px;
    max-width: 900px;

    @media (min-width: ${breakpoint.phone}) {
        margin-bottom: 40px;
    }
`;

export const Column = styled.div`
    margin-bottom: 16px;
    flex: 1;
`;

export const Typography = styled.div`
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.1px;
    word-wrap: break-word;
`;

export const HeaderTypography = styled(Typography)`
    font-size: 13px;
    line-height: 14px;
    color: ${colors.textSecondary};
    margin-bottom: 6px;
`;

export const CustomLink = styled(Link)`
    white-space: nowrap;
`;

export const CodeLinkButton = styled(Button)`
    color: ${colors.brandPrimary};
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    margin-bottom: 6px;
    width: auto;

    > span {
        white-space: nowrap;
        padding: 6px 10px;
    }
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 140px;

    animation: ${opacity} 2s ease;
`;
